/**
 * Query key factory for applies data hooks. Used for cache consistency and invalidation.
 */

export const appliesQueryKeys = {
  all: ["applies"] as const,

  /** GET /api/v2/Applies (paginated list). */
  list: (params: Record<string, unknown>) =>
    [...appliesQueryKeys.all, "list", params] as const,

  /** GET /api/v2/Applies/Metrics/Aggregated (supplementary metrics). */
  metrics: (params: Record<string, unknown>) =>
    [...appliesQueryKeys.all, "metrics", params] as const,

  /** GET /api/v2/Applies/FilterCounts. */
  filterCounts: (params: Record<string, unknown>) =>
    [...appliesQueryKeys.all, "filterCounts", params] as const,

  /** GET /api/v2/Applies/FilterCounts/{dimension} (one dimension, paged on scroll). */
  filterOptions: (dimension: string, params: Record<string, unknown>) =>
    [...appliesQueryKeys.all, "filterOptions", dimension, params] as const,

  /** GET /api/v2/Applies/{UUID} (single apply detail). */
  detail: (applyId: string) =>
    [...appliesQueryKeys.all, "detail", applyId] as const,

  /** GET /api/v2/Applies/{UUID}/Cockpit (cockpit info for an apply). */
  cockpit: (applyId: string) =>
    [...appliesQueryKeys.all, "cockpit", applyId] as const,

  /** GET /api/v2/Integrations/{integration}/applies/clients. */
  clients: (params: Record<string, unknown>) =>
    [...appliesQueryKeys.all, "clients", params] as const,
};
